export default "__VITE_ASSET__O9V7KCB___"